module.exports = __webpack_public_path__ + "static/plumbers-hero-e2a74e74bed89413c3946582aba967fa.png";